module.exports = __webpack_public_path__ + "img/enter.31286936.svg";